module.exports = __webpack_public_path__ + "public/Icons/pauseIcon.svg?5922b081";